"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
/**
 * Returns the string for the label of the checkbox fo the txp flag in the UI
 * @param flagName The name of the event flag
 */
function getLabelForTxpFlag(flagName) {
    switch (flagName) {
        case 'FlightEventsFromEmailEnabled':
            return owa_options_strings_1.default.options_txp_flights;
        case 'HotelEventsFromEmailEnabled':
            return owa_options_strings_1.default.options_txp_hotelReservations;
        case 'RentalCarEventsFromEmailEnabled':
            return owa_options_strings_1.default.options_txp_carRentals;
        case 'PackageDeliveryEventsFromEmailEnabled':
            return owa_options_strings_1.default.options_txp_packageDelivery;
        case 'DiningEventsFromEmailEnabled':
            return owa_options_strings_1.default.options_txp_diningReservations;
        case 'EntertainmentEventsFromEmailEnabled':
            return owa_options_strings_1.default.options_txp_events;
        case 'InvoiceEventsFromEmailEnabled':
            return owa_options_strings_1.default.options_txp_bills;
    }
}
exports.getLabelForTxpFlag = getLabelForTxpFlag;
/**
 * Checks the feature flags to determine if this event type is enabled
 * @param eventType The event type which should be validated
 */
function isEventTypeEnabled(eventType) {
    switch (eventType) {
        case 'DiningEventsFromEmailEnabled':
            return owa_controls_feature_flags_1.isControlFeatureEnabled('cal-txp-dining');
        case 'EntertainmentEventsFromEmailEnabled':
            return owa_controls_feature_flags_1.isControlFeatureEnabled('cal-txp-entertainment');
        case 'InvoiceEventsFromEmailEnabled':
            return owa_controls_feature_flags_1.isControlFeatureEnabled('cal-txp-invoice');
    }
    // All other events are enabled by default
    return true;
}
exports.isEventTypeEnabled = isEventTypeEnabled;
/**
 * Returns the list of all EventFlagTypes in the order they should be displayed in the UI
 */
exports.EventsInOptionsPageInOrder = [
    'FlightEventsFromEmailEnabled',
    'HotelEventsFromEmailEnabled',
    'RentalCarEventsFromEmailEnabled',
    'PackageDeliveryEventsFromEmailEnabled',
    'DiningEventsFromEmailEnabled',
    'EntertainmentEventsFromEmailEnabled',
    'InvoiceEventsFromEmailEnabled',
];
//# sourceMappingURL=getTxpFlagInfo.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-txp-option/lib/utils/getTxpFlagInfo.js
// module id = 5271
// module chunks = 2